/**
 * ReviewerDashboard — redirects to the active Evidence Review page.
 * The legacy provider evidence workflow was deprecated in Phase 12.
 */
import { Navigate } from 'react-router-dom';

export default function ReviewerDashboard() {
  return <Navigate to="/evidence-review" replace />;
}
